import * as backendMembers from '../../utils/ApiRest/backendMembers'
import * as actionsTypesMembers from '../actionsTypesMembers'

function updateUserMembersRequest(isLoading) {
  return {
    type: actionsTypesMembers.UPDATE_USER_MEMBERS_REQUEST,
    isLoading,
  }
}
function updateUserMembersFailure(isError) {
  return {
    type: actionsTypesMembers.UPDATE_USER_MEMBERS_FAILURE,
    isError,
  }
}
function updateUserMembersSuccess(isSuccess) {
  return {
    type: actionsTypesMembers.UPDATE_USER_MEMBERS_SUCCESS,
    isSuccess
  }
}
export function fetchUpdateUserMembersAction(userID, userData) {
  return function(dispatch, getState) {

    dispatch(updateUserMembersRequest(true))

    return backendMembers.updateUser(userID, userData)
      .then(response => {
        dispatch(updateUserMembersRequest(false))
        dispatch(updateUserMembersSuccess(true))
      })
      .catch(error => {
        dispatch(updateUserMembersRequest(false))
        dispatch(updateUserMembersFailure(true))
      })
  }
}

function updatePasswordMembersRequest(isLoading) {
  return {
    type: actionsTypesMembers.UPDATE_PASSWORD_MEMBERS_REQUEST,
    isLoading,
  }
}
function updatePasswordMembersFailure(isError) {
  return {
    type: actionsTypesMembers.UPDATE_PASSWORD_MEMBERS_FAILURE,
    isError,
  }
}
function updatePasswordMembersSuccess(isSuccess) {
  return {
    type: actionsTypesMembers.UPDATE_PASSWORD_MEMBERS_SUCCESS,
    isSuccess
  }
}
export function fetchUpdatePasswordMembersAction(oldPassword, password, email, userID) {
  return function(dispatch, getState) {

    dispatch(updatePasswordMembersRequest(true))

    return backendMembers.changePassword(oldPassword, password, email, userID)
      .then(response => {
        dispatch(updatePasswordMembersRequest(false))
        dispatch(updatePasswordMembersSuccess(true))
      })
      .catch(error => {
        dispatch(updatePasswordMembersRequest(false))
        dispatch(updatePasswordMembersFailure(true))
      })
  }
}



// WEBPACK FOOTER //
// ./src/actions/Reglages/MembersData.js